// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoScrollController from "./auto_scroll_controller"
application.register("auto-scroll", AutoScrollController)

import ChronologyController from "./chronology_controller"
application.register("chronology", ChronologyController)

import ConceptExplorerController from "./concept_explorer_controller"
application.register("concept-explorer", ConceptExplorerController)

import ConceptLinkController from "./concept_link_controller"
application.register("concept-link", ConceptLinkController)

import ErrorSummaryController from "./error_summary_controller"
application.register("error-summary", ErrorSummaryController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ReportNavigatorController from "./report_navigator_controller"
application.register("report-navigator", ReportNavigatorController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import SkipLinkController from "./skip_link_controller"
application.register("skip-link", SkipLinkController)

import TrendResultsController from "./trend_results_controller"
application.register("trend-results", TrendResultsController)
